import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {
  GelContentContainer,
  HeroBlock, Notice,  withAuthentication, FormErrorSummary, Loading, withRouter
} from "cw-styleguide-react";


import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {route} from "../../../../routes";
import {Helmet} from "react-helmet";
import CoursesTranslateForm from "../../components/translate/CoursesTranslateForm";
import {OPERATION_TRANSLATE_AMENDED} from "../../../../constants";

class CoursesTranslateAmendedView extends Component {

  render() {
    if (!this.props.loaded ) {
      return <GelContentContainer>
        <FormErrorSummary errors={this.props.formErrors}/>
        <Loading text={this.props.t('local:view.courses.edit.messages.loading')}/>
      </GelContentContainer>
    }
    return (
      <Fragment>

        <Helmet>
          <title>{this.props.t('view.courses.translateAmended.title')}</title>
        </Helmet>

        <BreadcrumbsItem to={route('coursesTranslateManage') + route('coursesTranslateAmended', {"course": this.props.values.id})}>
          {this.props.t('view.courses.translateAmended.breadcrumb')}
        </BreadcrumbsItem>

        <GelContentContainer>
          <h1>{this.props.t('local:view.courses.translateAmended.title')}</h1>
        </GelContentContainer>

        <HeroBlock>
          <p>{this.props.t('local:view.courses.translateAmended.introduction')}</p>
        </HeroBlock>





        <GelContentContainer>


          {this.props.messages.map((element, index) => {
            return <Notice type={element.type}>{element.message}</Notice>
          })}

          {/* Show the error summary */}
          <FormErrorSummary errors={this.props.formErrors} handleErrorClick={this.props.handleErrorClick} />
        </GelContentContainer>


        <CoursesTranslateForm {...this.props} operation={OPERATION_TRANSLATE_AMENDED}/>

      </Fragment>
    )
  }


}

export default withRouter(withAuthentication(withTranslation('local')(CoursesTranslateAmendedView)));
